import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export async function submitLead(payload) {
  const { data } = await axios.post(`${API}/leads`, payload);
  return data;
}

export async function createCheckout(lead_id, origin_url) {
  const { data } = await axios.post(`${API}/payments/checkout`, { lead_id, origin_url });
  return data;
}

export async function getStripeConfig() {
  const { data } = await axios.get(`${API}/payments/config`);
  return data;
}

export async function createEmbeddedCheckout(lead_id, tip_amount = 0) {
  const { data } = await axios.post(`${API}/payments/embedded-checkout`, { lead_id, tip_amount });
  return data;
}

export async function createTipCheckout(payload) {
  const { data } = await axios.post(`${API}/tips/checkout`, payload);
  return data;
}

export async function getPaymentStatus(session_id) {
  const { data } = await axios.get(`${API}/payments/status/${session_id}`);
  return data;
}

// ---- Pricing ----
export async function getPricing() {
  const { data } = await axios.get(`${API}/pricing`);
  return data;
}

export async function updatePricing(token, config) {
  const { data } = await axios.put(`${API}/pricing`, config, { headers: { Authorization: `Bearer ${token}` } });
  return data;
}

// ---- Admin ----
export async function adminLogin(email, password) {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  return data;
}

const authHeader = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export async function fetchMe(token) {
  const { data } = await axios.get(`${API}/auth/me`, authHeader(token));
  return data;
}

export async function fetchLeads(token) {
  const { data } = await axios.get(`${API}/leads`, authHeader(token));
  return data;
}

export async function updateLeadStatus(token, id, status) {
  const { data } = await axios.patch(`${API}/leads/${id}`, { status }, authHeader(token));
  return data;
}

export async function deleteLead(token, id) {
  const { data } = await axios.delete(`${API}/leads/${id}`, authHeader(token));
  return data;
}
